import type { UserState, UserStore } from './types';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { getUserPlanInfo } from '@/modules/Subscribe/helper';

function getDefaultStore(): UserState {
  return {
  userInfo: null,
  isLogin: false,
  isLoading: true,
  token: null,
  registerInfo: {},
  userPoints: undefined,
  userPointsStatus: 'normal',
  isFirstChangePointsStatus: false,
  paymentStatus: null,
  userPermissionList: null,
  isFreeUser: true,
  userSubscription: null,
  planInfo: { type: 'free', label: 'Free' },
  userCoupons: [],
};
}

export const useUserStore = create<UserStore>()(
  persist(
    (set, get) => ({
      ...getDefaultStore(),

      setUserInfo: (userInfo) => {
        set({ userInfo });
      },

      getUserInfo: () => {
        return get().userInfo;
      },

      getUserName: () => {
        return get().userInfo?.userName || '';
      },

      getEmail: () => {
        return get().userInfo?.email || '';
      },

      getAvatar: () => {
        return get().userInfo?.userImage || '';
      },

      resetUserStore: () => {
        set(getDefaultStore());
      },

      setIsLogin: (isLogin) => {
        set({ isLogin });
      },

      setRegisterInfo: (info) => {
        set({ registerInfo: { ...get().registerInfo, ...info } });
      },

      setToken: (token) => {
        set({ token });
      },

      checkAuth: () => {
        const state = get();

        if (state.userInfo) {
          set({
            isLogin: true,
            isLoading: false,
          });
        } else {
          set({
            userInfo: null,
            token: null,
            isLogin: false,
            isLoading: false,
          });
        }
      },

      setUserPoints: (points) => {
        set({ userPoints: points });
      },

      setUserPointsStatus: (status) => {
        set({ userPointsStatus: status });
      },

      setIsFirstChangePointsStatus: (isFirst) => {
        set({ isFirstChangePointsStatus: isFirst });
      },

      setPaymentStatus: (status) => {
        set({ paymentStatus: status });
      },

      setUserPermissionList: (permissionList) => {
        set({ userPermissionList: permissionList });
      },

      setIsFreeUser: (isFreeUser) => {
        set({ isFreeUser });
      },

      setUserCoupons: (coupons) => {
        set({ userCoupons: coupons ?? [] });
      },

      setUserSubscription: (subscription) => {
        const planInfo = getUserPlanInfo(subscription);
        set({
          userSubscription: subscription,
          isFreeUser: subscription?.exist !== true,
          planInfo,
        });
      },
    }),
    {
      name: 'wegic-builder-user-store',
      partialize: state => ({
        userInfo: state.userInfo,
        isLogin: state.isLogin,
      }),
    },
  ),
);
